import { t } from "./i18n";

/**
 * Maps an axios error (from AI-related endpoints) to a user-friendly localized message.
 * Handles: Cloudflare 524 / 504, network errors, timeouts, AI budget exhaustion, and generic 500s.
 */
export function aiErrorMessage(error, lang = "en") {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail || "";
  const code = error?.code;

  // 402 → AI budget exhausted
  if (status === 402 || /budget/i.test(detail)) {
    return t(lang, "ai_budget");
  }

  // 429 → rate limit (AI side, not daily limit)
  if (status === 429 && /ai|rate/i.test(detail)) {
    return t(lang, "ai_overloaded");
  }

  // Cloudflare 524 / 504 gateway timeout
  if (status === 524 || status === 504) {
    return t(lang, "ai_overloaded");
  }

  // Axios timeout (ECONNABORTED) or network error
  if (code === "ECONNABORTED" || /timeout/i.test(error?.message || "")) {
    return t(lang, "ai_timeout");
  }

  if (code === "ERR_NETWORK" || (!status && !detail)) {
    return t(lang, "ai_overloaded");
  }

  // 502/503 → transient AI/upstream error
  if (status === 502 || status === 503) {
    return t(lang, "ai_overloaded");
  }

  // 500 with generic story generation failure
  if (status === 500 && /story|generation|chat completion|overloaded/i.test(detail)) {
    return t(lang, "ai_overloaded");
  }

  // Fallback: backend detail message or generic error
  return detail || t(lang, "generation_error");
}
